var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.615V15.615M12 17.615V13.615M15 17.615V11.615M17 21.615H7C5.89543 21.615 5 20.7196 5 19.615V5.61499C5 4.51042 5.89543 3.61499 7 3.61499H12.5858C12.851 3.61499 13.1054 3.72035 13.2929 3.90788L18.7071 9.3221C18.8946 9.50963 19 9.76399 19 10.0292V19.615C19 20.7196 18.1046 21.615 17 21.615Z",
    stroke: "#9DA3AE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/Billing.c4034f96f14b0dba678e1e8e3810127e.svg";
export { ForwardRef as ReactComponent };